/**
 * sl-locations.js — city filter + card expand for Onde Encontrar
 * Engine is DOM-driven (data-* on [data-sl-locations]).
 */
(function () {
  'use strict';

  var ROOT = '[data-sl-locations]';

  function Locations(el) {
    this.el = el;
    this.select = el.querySelector('[data-sl-locations-select]');
    this.cityButtons = el.querySelectorAll('[data-sl-locations-city]');
    this.cards = el.querySelectorAll('[data-sl-locations-card]');
    this.emptyPick = el.querySelector('[data-sl-locations-empty="pick"]');
    this.emptyCity = el.querySelector('[data-sl-locations-empty="city"]');
    this.city = el.getAttribute('data-initial-city') || '';
    this.bind();
    this.apply(this.city);
  }

  Locations.prototype.bind = function () {
    var self = this;
    if (this.select) {
      this.select.addEventListener('change', function () {
        self.apply(self.select.value);
      });
    }
    this.cityButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.apply(btn.getAttribute('data-sl-locations-city') || '');
      });
    });
    this.el.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-sl-locations-trigger]');
      if (!trigger || !self.el.contains(trigger)) return;
      self.toggleCard(trigger);
    });
  };

  Locations.prototype.apply = function (city) {
    this.city = city || '';
    var visible = 0;

    if (this.select && this.select.value !== this.city) {
      this.select.value = this.city;
    }

    this.cityButtons.forEach(function (btn) {
      var on = btn.getAttribute('data-sl-locations-city') === city;
      btn.classList.toggle('is-active', on);
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });

    this.cards.forEach(function (card) {
      var match = city !== '' && card.getAttribute('data-cidade') === city;
      card.hidden = !match;
      card.classList.toggle('is-visible', match);
      if (!match) {
        var trigger = card.querySelector('[data-sl-locations-trigger]');
        var detail = card.querySelector('[data-sl-locations-detail]');
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
        if (detail) detail.hidden = true;
        card.classList.remove('is-open');
      }
      if (match) visible += 1;
    });

    if (this.emptyPick) this.emptyPick.hidden = this.city !== '';
    if (this.emptyCity) this.emptyCity.hidden = !(this.city !== '' && visible === 0);
  };

  Locations.prototype.toggleCard = function (trigger) {
    var card = trigger.closest('[data-sl-locations-card]');
    if (!card) return;
    var detail = card.querySelector('[data-sl-locations-detail]');
    if (!detail) return;
    var open = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
    detail.hidden = open;
    card.classList.toggle('is-open', !open);
  };

  function boot(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var nodes = scope.querySelectorAll(ROOT);
    if (root && root.matches && root.matches(ROOT)) {
      nodes = [root];
    }
    nodes.forEach(function (el) {
      if (el.__slLocations) return;
      el.__slLocations = new Locations(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var el = e.target && e.target.querySelector && e.target.querySelector(ROOT);
    if (el) el.__slLocations = null;
  });
})();
